import React from 'react';
import { Check } from 'lucide-react';
interface PackageCardProps {
  title: string;
  price: string;
  originalPrice?: string;
  description: string;
  features: string[];
  popular?: boolean;
  saving?: string;
  link: string;
}
const PackageCard: React.FC<PackageCardProps> = ({
  title,
  price,
  originalPrice,
  description,
  features,
  popular = false,
  saving,
  link
}) => {
  return <div className={`
      bg-white rounded-lg shadow-lg overflow-hidden border-2
      ${popular ? 'border-burgundy-500 transform scale-105 md:scale-110' : 'border-pink-300'}
    `} data-id="element-299">
      {popular && <div className="bg-burgundy-600 text-white text-center py-2 font-medium" data-id="element-300">
          Most Popular
        </div>}
      <div className="p-6" data-id="element-301">
        <h3 className="text-xl font-bold mb-2" data-id="element-302">{title}</h3>
        <div className="flex items-baseline mb-4" data-id="element-303">
          <span className="text-3xl font-bold" data-id="element-304">{price}</span>
          {originalPrice && <span className="ml-2 text-gray-500 line-through" data-id="element-305">
              {originalPrice}
            </span>}
        </div>
        {saving && <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium inline-block mb-4" data-id="element-306">
            Save {saving}
          </div>}
        <p className="text-gray-600 mb-6" data-id="element-307">{description}</p>
        <ul className="space-y-2 mb-6" data-id="element-308">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-309">
              <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-310" />
              <span data-id="element-311">{feature}</span>
            </li>)}
        </ul>
        <a href={link} target="_blank" rel="noopener noreferrer" className={`
            block w-full text-center py-2 rounded-md font-medium transition-colors
            ${popular ? 'bg-burgundy-600 hover:bg-burgundy-700 text-white' : 'bg-burgundy-400 hover:bg-burgundy-500 text-white'}
          `} data-id="element-312">
          Book Now
        </a>
      </div>
    </div>;
};
export default PackageCard;